import { render } from "./imageTextCarousel.vue?vue&type=template&id=0c5e24af&scoped=true"
import script from "./imageTextCarousel.vue?vue&type=script&lang=js"
export * from "./imageTextCarousel.vue?vue&type=script&lang=js"

import "./imageTextCarousel.vue?vue&type=style&index=0&id=0c5e24af&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5e24af"]])

export default __exports__